import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { IconName } from '@fortawesome/free-solid-svg-icons';

export type IconSize = 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '2x' | '3x' | '5x' | '7x' | '10x';
@Component({
  selector: 'sigecom-menu-bar-item',
  template: `
    <button (click)="clickAction.emit()" type="button" class="w-full flex items-center gap-3">
      <fa-icon *ngIf="icon" [size]="size" [icon]="icon!" class="text-{{color}}" />
      <span *ngIf="label" class="font-medium text-mms-text-primary text-lg">{{ label }}</span>
    </button>
  `,
  styles: [
  ]
})
export class MenuBarItemComponent {
  @Input() label?: string;
  @Input() icon?: IconName;
  @Input() color: string = 'sigecom-info';
  @Input() size?: IconSize;
  @Output() clickAction: EventEmitter<void> = new EventEmitter<void>();

  protected showTooltip = signal(false);
}
